import Vue from 'vue'
import './cube-ui'
import App from './App.vue'
import fastClick from 'fastclick'
import 'babel-polyfill'
import router from './router'
import store from '@/store/store'
import '@style/reset.css'
import '@style/iconfont.css'
import '@style/border.css'
import '@js/vant.js'
import { redirect, getCache, setCache, delCache, checkedAll, number_format } from '@util/functions'
import vueg from 'vueg'
import '@/vant'
import VueClipboard from 'vue-clipboard2'

//复制到粘贴板插件
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(vueg, router, {
  enter: 'fadeInRight',  //fadeInRight touchPoint
  leave: 'fadeInLeft'
})
Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.prototype.$redirect = redirect
Vue.prototype.$setCache = setCache
Vue.prototype.$getCache = getCache
Vue.prototype.$delCache = delCache
Vue.prototype.$checkedAll = checkedAll
Vue.prototype.$number_format = number_format
Vue.prototype.$store = store

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

